import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTypesAll = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 36 36",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M25.6923 7.50635H21.1189C19.46 7.50635 18.4941 8.40039 18.4941 9.93233V15.1208C18.4941 16.6779 19.46 17.5518 21.1189 17.5518H25.6923C27.3779 17.5518 28.3165 16.6779 28.3165 15.1208V9.93233C28.3165 8.40039 27.3779 7.50635 25.6923 7.50635Z",
			fill: "url(#paint0_linear_10904_5988)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.29686 21.1562C10.0667 19.8229 11.9912 19.8229 12.761 21.1563L15.8549 26.5152C16.6247 27.8485 15.6625 29.5152 14.1229 29.5152H7.93494C6.39534 29.5152 5.43309 27.8485 6.20289 26.5152L9.29686 21.1562Z",
			fill: "url(#paint1_linear_10904_5988)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 11.029,
			cy: 12.529,
			r: 5.24169,
			fill: "url(#paint2_linear_10904_5988)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M26.8506 25.7806C26.6971 25.9255 26.6247 26.137 26.6565 26.3458L27.139 29.2319C27.1797 29.4766 27.0734 29.7222 26.8673 29.8605C26.6653 30.0042 26.3988 30.0183 26.182 29.8984L23.6078 28.5125C23.5183 28.4633 23.4186 28.4362 23.3162 28.432L23.1576 28.4299C23.1025 28.4374 23.0484 28.4542 22.9989 28.4805L20.3885 29.8048C20.2595 29.8675 20.1141 29.8884 19.9721 29.8637C19.6266 29.7936 19.3997 29.4605 19.4611 29.1131L20.0197 26.2406C20.057 26.0309 19.9901 25.8164 19.8405 25.6652L17.7541 23.5892C17.5796 23.4154 17.5216 23.1571 17.6054 22.9258C17.6868 22.6951 17.8892 22.5286 18.1314 22.4937L21.0455 22.1099C21.267 22.09 21.4631 21.9579 21.5652 21.7603L22.8813 19.1494C22.9125 19.0913 22.9524 19.038 23.0004 18.9929L23.0536 18.9527C23.0816 18.9226 23.1135 18.8978 23.1489 18.8778L23.213 18.8553L23.313 18.8156L23.5594 18.8188C23.7791 18.8445 23.9711 18.9788 24.0698 19.1767L25.3341 21.8097C25.4252 22.0023 25.6054 22.1375 25.8151 22.1725L28.7182 22.6326C28.9635 22.6709 29.1667 22.8434 29.245 23.0785C29.3185 23.3142 29.249 23.5708 29.0666 23.7376L26.8506 25.7806Z",
			fill: "url(#paint3_linear_10904_5988)"
		}),
		/* @__PURE__ */ _jsx("g", {
			opacity: .5,
			filter: "url(#filter0_f_10904_5988)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M25 23.5143C23.8234 23.0679 22.506 23.6607 22.0596 24.8372C21.6131 26.014 22.2058 27.3311 23.3825 27.7775C24.5612 28.2247 25.8763 27.6315 26.3228 26.4547C26.7692 25.2783 26.1788 23.9616 25 23.5143Z",
				fill: "#FF3D22"
			})
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter0_f_10904_5988",
				x: 17.4579,
				y: 18.9128,
				width: 13.4667,
				height: 13.4667,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "BackgroundImageFix",
						result: "shape"
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", {
						stdDeviation: 2.22647,
						result: "effect1_foregroundBlur_10904_5988"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint0_linear_10904_5988",
				x1: 28.3165,
				y1: 7.50635,
				x2: 21.2105,
				y2: 15.6325,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#5FD05F" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#43BE5D"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint1_linear_10904_5988",
				x1: 11.0289,
				y1: 18.1562,
				x2: 11.0289,
				y2: 33.3015,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#FFE7A7" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#FFD054"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint2_linear_10904_5988",
				x1: 11.029,
				y1: 7.28735,
				x2: 11.029,
				y2: 17.7707,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#398EFE" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#5EA4FC"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint3_linear_10904_5988",
				x1: 18.844,
				y1: 21.7959,
				x2: 26.1215,
				y2: 36.6598,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#FFA78F" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#F23E2C"
				})]
			})
		] })
	]
});
export default SvgTypesAll;
